import React, { useState, useCallback, useEffect } from "react";
import { Button, FormLayout, TextField } from "@shopify/polaris";
const AppSettingsListItem = (props) => {
  const handleChangeKey = (newValue) => {
    props.handleUpdateItem(newValue, "key", props.id);
  };
  const handleChangeValue = (newValue) => {
    props.handleUpdateItem(newValue, "value", props.id);
  };

  return (
    <div style={{ marginTop: "0.1rem" }}>
      <FormLayout>
        <FormLayout.Group condensed>
          <TextField
            label="Key"
            value={props.keyField}
            onChange={handleChangeKey}
          />
          <TextField
            label="Value"
            value={props.value}
            onChange={handleChangeValue}
            connectedRight={
              <Button
                destructive
                onClick={() => props.handleRemoveItem(props.id)}
              >
                Delete
              </Button>
            }
          />
        </FormLayout.Group>
        {/* <Button
          destructive
          size="slim"
          onClick={() => props.handleRemoveChoicelistItem(props.id)}
        >
          Delete
        </Button> */}
      </FormLayout>
    </div>
  );
};

export default AppSettingsListItem;
